import { Link } from 'react-router-dom'
import classNames from 'classnames'

import keysight from 'assets/img/common/keysight-logo.svg'

import styles from './styles.module.scss'

export const BringAiCards = () => {
  return (
    <section className={styles.BringAiCards}>
      <div className={classNames(styles.containerBig, 'container')}>
        <div className="row justify-content-center">
          <div className={classNames(styles.bacFirst, 'col-12 col-md-6')}>
            <div
              className={styles.main + ' text-center text-md-left'}
              data-aos="fade-up"
              data-aos-duration="700"
            >
              <div className={styles.headline}>
                <h4>FREE Workshops in Emerging Technologies</h4>
                <h5>
                  Funded by <img src={keysight} alt="Keysight" />
                </h5>
              </div>
              <div className={styles.desc}>
                <p>
                  Funded by Keysight Technologies, The Coding School is
                  providing
                  <span className="text-bold text-underline"> free</span>,
                  1-hour virtual workshops customized to your middle and high
                  school classrooms across the United States. These engaging
                  sessions will feature interactive discussions, hands-on
                  activities, and real-world applications, helping students
                  explore foundational concepts, career opportunities, and
                  essential skills in cutting-edge industries.
                </p>
              </div>
              <div className={styles.buttonsWrap}>
                <a
                  href="https://airtable.com/appAgeNP0hq6rXtT0/pagifuoMwrfUdxzoB/form"
                  className={
                    styles.button +
                    ' btn btn-primary-gradient text-upper text-white text-bold py-10 rounded-0'
                  }
                  target="_blank"
                  rel="noreferrer"
                >
                  Request a workshop
                </a>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div
              className={styles.main + ' text-center text-md-left'}
              data-aos="fade-up"
              data-aos-duration="700"
            >
              <div className={styles.headline}>
                <h4>Professional Development Course For Educators</h4>
              </div>
              <div className={styles.desc}>
                <p>
                  High school educators, join our 1-week Summer 2026
                  professional development (PD): Introduction to Artificial
                  Intelligence & Machine Learning. Educators will develop the
                  most cutting-edge AI skills and knowledge in topics including
                  GenAI, Deep Learning & Neural Networks! They also receive
                  lesson plans they can integrate into their existing curricula
                  and an opportunity to join an online community of like-minded
                  educators who are bringing AI into their classrooms and
                  receiving implementation support throughout the year. CEUs
                  will be received upon successful completion of the PD
                  training.
                </p>
              </div>
              <div className={styles.buttonsWrap}>
                {/* <a
                  href="https://pathfinders.onwingspan.com/web/en/login"
                  className={
                    styles.button +
                    ' btn btn-primary-gradient text-upper text-white text-bold py-10 rounded-0'
                  }
                  target="_blank"
                  rel="noreferrer"
                >
                  Create Account
                </a> */}
                <a
                  href="https://airtable.com/appdS9n7K25uof6m4/shrk9rCX4MuD6T0HY"
                  className={
                    styles.button +
                    ' btn btn-primary-gradient text-upper text-white text-bold py-10 rounded-0'
                  }
                  target="_blank"
                  rel="noreferrer"
                >
                  2026 Interest form
                </a>
              </div>
              {/* <p className={styles.smallText}>
                Create an account & then register by clicking above
              </p> */}
            </div>
          </div>

          {/* <div className="col-12 col-md-6 mt-30">
            <div
              className={classNames(styles.main, 'text-center text-md-left')}
              data-aos="fade-up"
              data-aos-duration="600"
            >
              <div className={styles.headline}>
                <h4>Offer As A For-Credit Or Afterschool Course</h4>
              </div>
              <div className={styles.desc}>
                <p>
                  <span className="text-bold">
                    Nationally accredited by WASC
                  </span>
                  , we offer our two-semester{' '}
                  <span className="text-italic">Introduction to ML</span> course
                  for high school credit at participating schools and school
                  districts. We provide the weekly instruction; assignments,
                  including problem sets, homework and projects; and grading and
                  transcripts; all that we require of participating schools is
                  that they approve to offer the course for transcript credit.
                  We work with individual schools, school districts, and
                  statewide DOEs. This course is fully funded by DoDSTEM and
                  there is no cost to our school partners or students. To learn
                  more about how to offer this course for credit complete the
                  form below.
                </p>
              </div>
              <Link
                className={
                  styles.button +
                  ' btn btn-primary-gradient text-upper text-white text-bold py-10 rounded-0'
                }
                to="/school-partner-info"
              >
                Connect with Us
              </Link>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  )
}
